/**
 * @generated SignedSource<<5d5b24cd64e723b340bf09b9db946a24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type TodoCategoryEditGeneralScreenQuery$variables = {
  id: string;
};
export type TodoCategoryEditGeneralScreenQuery$data = {
  readonly todoCategory: {
    readonly icon: TodoCategoryIcon | null;
    readonly id: string;
    readonly isDefault: boolean;
    readonly title: string;
  };
};
export type TodoCategoryEditGeneralScreenQuery = {
  response: TodoCategoryEditGeneralScreenQuery$data;
  variables: TodoCategoryEditGeneralScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoCategory",
    "kind": "LinkedField",
    "name": "todoCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryEditGeneralScreenQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryEditGeneralScreenQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf843b668875483e6bfb9b81efac8de7",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryEditGeneralScreenQuery",
    "operationKind": "query",
    "text": "query TodoCategoryEditGeneralScreenQuery(\n  $id: ID!\n) {\n  todoCategory(id: $id) {\n    id\n    title\n    icon\n    isDefault\n  }\n}\n"
  }
};
})();

(node as any).hash = "c26251203b312ace95ccf39b37f001b1";

export default node;
